import React from "react";
import useStyles from "../styles/styles";
import van from "../assets/img/minivan_342053 1.svg";
import speed from "../assets/img/acceleration_16318834.svg";
import safety from "../assets/img/shield_1962520.svg";
import clock from "../assets/img/alarm-clock_1760564.svg";
import { useTranslation } from "react-i18next";

const CoreValues = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.coreValuesContainerDiv}>
      <div className={classes.spacings}>
        <div className={classes.coreValuesContainer}>
          <h2 className={classes.h2CoreValuesContainer}> {t("coreValues")}</h2>
          <div className={classes.valuesContainer}>
            <div className={classes.valueContainer}>
              <img className={classes.valueImage} src={van} alt="Comfort" />
              <p className={classes.valuePText}>{t("comfort")}</p>
            </div>
            <div className={classes.valueContainer}>
              <img className={classes.valueImage} src={speed} alt="Speed" />
              <p className={classes.valuePText}>{t("speed")}</p>
            </div>

            <div className={classes.valueContainer}>
              <img className={classes.valueImage} src={safety} alt="Safety" />
              <p className={classes.valuePText}>{t("safety")}</p>
            </div>
            <div className={classes.valueContainer}>
              <img
                className={classes.valueImage}
                src={clock}
                alt="Convenience"
              />
              <p className={classes.valuePText}>{t("convenience")}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoreValues;
